// @flow
import * as React from 'react';
import Checkbox from 'components/Checkbox';
import { invert } from 'utils/functional';
import Field from './Field';

const CheckboxField = ({
  name,
  label,
  description,
  ...props
}: {
  name: string,
  label: React.Node,
  description?: string,
  // An optional map of stored form value to checked state
  // Useful if you want to submit something other than true / false
  // E.g., {STATE1: true, STATE2: false}. Checked corresponds to
  // the string 'STATE1'
  // TODO: use ES6 map to extend past strings / avoid type issues
  valueToChecked?: { [string]: boolean }
}) => (
  <Field
    inputProps={props}
    name={name}
    description={description}
    renderInput={({ value, id, qaId, hasError, updateValue }) => {
      const { valueToChecked } = props;
      const trueFalseMap = valueToChecked && invert(valueToChecked);
      const checked = (valueToChecked ? valueToChecked[value] : value) || false;

      return (
        <Checkbox
          id={id}
          name={name}
          label={label}
          checked={checked}
          hasError={hasError}
          onChange={
            trueFalseMap
              ? v => updateValue(trueFalseMap[v.toString()])
              : updateValue
          }
          data-qa-id={qaId}
          {...props}
        />
      );
    }}
  />
);

export default CheckboxField;
